import React, { useState } from "react";
import { RiMovie2Line } from "react-icons/ri";
import { FiLogIn } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
// import Inputs from "../components/Inputs";

const StartPageLogin = () => {
  // useNavigate to navigate to our homepage after login
  const navigate = useNavigate();

  // usestate for holding our initial state and rendering possible outcome
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState([]);

  //handlesubmit function for creating a response when the validation response has been reached
  const handleSubmit = (event) => {
    event.preventDefault();

    const validationErrors = validateLoginForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      navigate("/home");
    }
  };

  //validtion the form to check for errors
  const validateLoginForm = () => {
    const errors = {};
    if (!email) {
      errors.email = "Email is required";
    }
    if (!password) {
      errors.password = "Password is required";
    }
    return errors;
  };

  return (
    // background image with a fainted appearance
    <div className="relative w-full lg:h-full h-screen">
      {/* Image section */}
      <img
        src="/images/wallpaper.jpg"
        alt="start-page"
        className="object-cover w-full h-full z-auto"
      />

      {/* Form section */}
      <div className="w-full flex items-center justify-center bg-gray-900/80 absolute top-0 left-0">
        <form onSubmit={handleSubmit} className="max-w-lg mx-auto">
          <div className="bg-gray-900/80 absolute top-0 left-0 w-full md:w-full h-full">
            <div className="container mx-auto px-2 flex-colo">
              <div className="w-full md:w-3/5 2xl:w-2/5 gap-4 my-36 flex-colo p-8 sm:p-14 bg-dry opacity-90 rounded-lg border border-border">
                {/* Logo */}
                <Link className="flex font-bold text-subMain text-6xl" to="/">
                  O{" "}
                  <span className="flex text-3xl text-white py-4">
                    scar'sTv
                    <RiMovie2Line color="red" />
                  </span>
                </Link>

                {/* Email input */}
                <input
                  label="Email"
                  type="email"
                  placeholder="email@gmail.com"
                  id="email"
                  className="w-full text-sm h-9 lg:h-14 p-2 text-black border border-border rounded"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                />
                <p className="text-slate-200 pt-1 text-sm">{errors.email}</p>

                {/* Password input */}
                <input
                  label="Password"
                  id="password"
                  placeholder="*********"
                  type="password"
                  className="w-full text-sm h-9 lg:h-14 p-2 text-black border border-border rounded"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                />
                <p className="text-slate-200 text-sm">{errors.password}</p>

                {/* Submit button */}
                <button
                  type="submit"
                  className="bg-subMain transitions lg:h-auto h-12 hover:bg-main flex-rows gap-4 text-white p-4 rounded-lg w-full"
                >
                  <FiLogIn /> Sign In
                </button>

                {/* Link to registration page */}
                <p className="text-center text-border">
                  Don't have an account?{" "}
                  <Link
                    to="/startregister"
                    className="text-text font-semibold ml-2"
                  >
                    Sign Up
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default StartPageLogin;
